import React from 'react';

const MetricCard = ({ icon, title, value }) => {
  return (
    <div className="bg-card rounded-lg shadow p-6">
      <div className="flex items-center gap-2">
        {icon}
        <h3 className="text-muted-foreground text-sm font-medium">{title}</h3>
      </div>
      <p className="text-2xl font-semibold mt-2">{value}</p>
    </div>
  );
};

export default MetricCard; 